var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8F97AA",
    d: "M10 18.667q-1.785 0-3.364-.678a8.7 8.7 0 0 1-2.764-1.861 8.7 8.7 0 0 1-1.861-2.764A8.45 8.45 0 0 1 1.333 10q0-1.804.678-3.375A8.737 8.737 0 0 1 6.636 2.01 8.45 8.45 0 0 1 10 1.334q1.805 0 3.374.678a8.768 8.768 0 0 1 4.615 4.615A8.4 8.4 0 0 1 18.666 10q0 1.784-.677 3.364a8.74 8.74 0 0 1-4.615 4.625 8.4 8.4 0 0 1-3.374.678m0-2.042q1.083 0 2.073-.344a7 7 0 0 0 1.822-.948L4.667 6.104a7 7 0 0 0-.948 1.823q-.343.99-.343 2.073 0 2.75 1.937 4.688T10 16.625m5.333-2.73a7 7 0 0 0 .948-1.822q.345-.99.344-2.073 0-2.75-1.938-4.687T10 3.375q-1.085 0-2.073.344-.99.344-1.823.948z"
  })));
};
export default SvgClose;